import React, { useState } from 'react';
import styled from 'styled-components';

const CopyableSpan = styled.span`
    color: ${({ theme }) => theme?.colors?.primary?.main || '#667eea'};
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    position: relative;

    &:hover {
        background: ${({ theme }) => theme?.colors?.primary?.light || '#667eea'}15;
        text-decoration: underline;
    }
`;

const Tooltip = styled.div`
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
    background: ${({ theme }) => theme?.colors?.gray?.[800] || '#2d3748'};
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    animation: fadeIn 0.2s ease-out;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid ${({ theme }) => theme?.colors?.gray?.[800] || '#2d3748'};
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateX(-50%) translateY(-5px);
        }
        to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
        }
    }
`;

export default function CopyableText({ text, displayText }) {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text || displayText);
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000);
        } catch (error) {
            // Fallback para navegadores mais antigos
            const textArea = document.createElement('textarea');
            textArea.value = text || displayText;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setShowTooltip(true);
                setTimeout(() => setShowTooltip(false), 2000);
            } catch (err) {
                // Silently fail
            }
            document.body.removeChild(textArea);
        }
    };

    if (!text && !displayText) {
        return <span style={{ color: '#999' }}>-</span>;
    }

    return (
        <CopyableSpan onClick={handleCopy} title="Clique para copiar">
            {displayText || text}
            {showTooltip && <Tooltip>Copiado!</Tooltip>}
        </CopyableSpan>
    );
}
